import script from "./LargeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LargeButton.vue?vue&type=script&setup=true&lang=js"

import "./LargeButton.vue?vue&type=style&index=0&id=e64efb40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e64efb40"]])

export default __exports__